// extracted by mini-css-extract-plugin
export default {"OfficeHeader":"office-header_OfficeHeader__ZeUBq","OfficeHeader__links":"office-header_OfficeHeader__links__TbQ7O"};